const SoundsInfoActionTypes = {
    ADD_AUDIO_CONTEXT : 'ADD_AUDIO_CONTEXT',
    ADD_ITEMS_TO_SOUNDS_INFO_ARRAY : 'ADD_ITEMS_TO_SOUNDS_INFO_ARRAY',
    ADD_NEW_ITEM_TO_SOUNDS_INFO_ARRAY : 'ADD_NEW_ITEM_TO_SOUNDS_INFO_ARRAY',
    ADD_ITEM_TO_PLAYING_SOUNDS_LIST : 'ADD_ITEM_TO_PLAYING_SOUNDS_LIST',
    UPDATE_SOUND_INFO_ARRAY : 'UPDATE_SOUND_INFO_ARRAY',
    ADD_VOICE_TO_VOICES_LIST : 'ADD_VOICE_TO_VOICES_LIST',
}

export default SoundsInfoActionTypes